import { Component, Vue } from 'vue-property-decorator';
import router from './routes';
import store from './store';
import { namespace, State } from 'vuex-class';
import { UIState } from './store/ui/types';
import { StationFactory } from './shared/factory/station-factory/station-factory';
import moment from 'moment';
import { ActiveWorkspaceState } from './store/auth/types';
import { AuthenticationService } from './modules/authentication/services/authentication.service';
import BSSidebarComponent from './shared/layout/bs-sidebar';
import { BSTaskbarComponent } from './shared/layout/bs-taskbar/bs-taskbar';

const uiModule = namespace('ui');
const authModule = namespace('auth');

@Component({
    router: router(),
    store: store,
    template: require('./app.html'),
    components: {
        'bs-taskbar': BSTaskbarComponent,
        'bs-sidebar': BSSidebarComponent,
    }
})
export class AppComponent extends Vue {
    @State('ui') ui: UIState;
    email: string;
    @authModule.Getter('activeWorkspace') activeWorkspace: ActiveWorkspaceState;
    @uiModule.Mutation('sidebarExpanded') sidebarExpanded;

    private _factory: StationFactory;
    sidebarExpand = false;

    created() {
        if (AuthenticationService.isAuthenticated) {
            this.email = AuthenticationService.user.email;
        }
    }


    async mounted() {
        this._factory = new StationFactory();
        const expireString = +localStorage.getItem('stations_expire_in');
        const expireIn = moment.unix(expireString);
        if (expireString === null || expireIn.isBefore(moment())) {
            this._factory.getStations().then((stations) => {
                localStorage.setItem('stations_expire_in', moment().add(7, 'days').format('X'));
                localStorage.setItem('stations', JSON.stringify(stations));
            });
        }
    }

    isTaskbarVisible() {
        // return this.ui.appVisible && this.loggedIn;
        return this.ui.appVisible && AuthenticationService.isAuthenticated;
    }

    isSidebarVisible() {
        // return this.ui.appVisible && this.loggedIn && this.ui.sidebarVisible;
        return this.ui.appVisible && AuthenticationService.isAuthenticated && this.ui.sidebarVisible;
    }

    open(direction, event) {
        if (event.path.find(i => i.className === 'table-responsive')) {
            return;
        }
        this.sidebarExpanded(true);
    }

    close() {
        this.sidebarExpanded(false);
    }

    handleTaskbarToggleExpand(expand: boolean) {
        this.sidebarExpand = expand;
    }

    handleSidebarHover(hover: boolean) {
        this.sidebarExpand = hover;
    }
}
